import React, { useEffect } from "react"

interface UseFixScrollOffsetProps {
  containerRef?: React.RefObject<HTMLDivElement>
  innerRef?: React.RefObject<HTMLDivElement>
  enabled?: boolean
  refresher?: any
}

function useFixScrollOffset(props: UseFixScrollOffsetProps) {
  const { containerRef, innerRef } = props

  useEffect(() => {
    if (!props.enabled) return
    const container = containerRef?.current
    const inner = innerRef?.current

    if (!container || !inner) return

    const fixScrollbarShift = () => {
      const scrollbarWidth = container.offsetWidth - container.clientWidth

      if (container.scrollHeight > container.clientHeight) {
        inner.style.paddingLeft = `${scrollbarWidth}px`
      } else {
        inner.style.paddingLeft = "0px"
      }
    }

    fixScrollbarShift()

    window.addEventListener("resize", fixScrollbarShift)
    return () => window.removeEventListener("resize", fixScrollbarShift)
  }, [containerRef, innerRef, props.enabled, props.refresher])
}

export default useFixScrollOffset
